module.exports = __webpack_public_path__ + "static/img/normal.136dc18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/normal.png
// module id = Q+UG
// module chunks = 2